module.exports = __webpack_public_path__ + "static/logo_pays_oc-d59b50f9fca5fe81180f8d84e56f8348.png";